import React from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

const splitHeaderText = (text) => {
	if (!text || typeof text !== "string") return { text, isSingleWord: false };

	const words = text.split(" ");
	const connectors = ["y", "o", "de", "a", "en", "del", "la", "el", "los", "las"];

	if (words.length === 1) {
		return { text, isSingleWord: true };
	}

	if (words.length === 2) {
		return { text: words.join("\n"), isSingleWord: false };
	}

	if (words.length === 3 && connectors.includes(words[1].toLowerCase())) {
		return { text: `${words[0]} ${words[1]}\n${words[2]}`, isSingleWord: false };
	}

	if (words.length >= 3) {
		for (let i = 1; i < words.length - 1; i++) {
			if (connectors.includes(words[i].toLowerCase())) {
				return { text: `${words.slice(0, i + 1).join(" ")}\n${words.slice(i + 1).join(" ")}`, isSingleWord: false };
			}
		}
		const mid = Math.ceil(words.length / 2);
		return { text: `${words.slice(0, mid).join(" ")}\n${words.slice(mid).join(" ")}`, isSingleWord: false };
	}

	return { text, isSingleWord: false };
};

const TableHeader = ({ styles, headerTableRef, headerGroups, renderSharedColGroup, compactHeaders }) => {
	return (
		<table ref={headerTableRef} className={styles.table} role="table">
			{renderSharedColGroup()}
			<thead className={styles.thead}>
				{headerGroups.map((headerGroup) => {
					const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
					return (
						<tr {...hgProps} key={hgKey}>
							{headerGroup.headers.map((column) => {
								const isColumnSortable = column.canSort;
								const sortableProps = isColumnSortable ? column.getSortByToggleProps() : {};
								const { key: thKey, ...thProps } = column.getHeaderProps(sortableProps);
								return (
									<th
										{...thProps}
										key={thKey}
										className={`${styles.th} ${isColumnSortable ? styles.thSortable : ""} ${compactHeaders ? styles.thCompact : ""} ${
											compactHeaders && typeof column.Header === "string" && splitHeaderText(column.Header).isSingleWord
												? styles.thCentered
												: ""
										}`}
										title={isColumnSortable ? "Ordenar" : undefined}
										scope="col"
									>
										<span className={styles.thInner}>
											{compactHeaders && typeof column.Header === "string"
												? (() => {
														const { text } = splitHeaderText(column.Header);
														return text.split("\n").map((line, i, arr) => (
															<React.Fragment key={i}>
																{line}
																{i < arr.length - 1 && <br />}
															</React.Fragment>
														));
													})()
												: column.render("Header")}
											{isColumnSortable ? (
												column.isSorted ? (
													column.isSortedDesc ? (
														<ArrowDown className={styles.sortIcon} strokeWidth={2} aria-label="Orden descendente" />
													) : (
														<ArrowUp className={styles.sortIcon} strokeWidth={2} aria-label="Orden ascendente" />
													)
												) : (
													<ArrowUpDown className={`${styles.sortIcon} ${styles.sortIdle}`} strokeWidth={2} aria-hidden="true" />
												)
											) : null}
										</span>
									</th>
								);
							})}
						</tr>
					);
				})}
			</thead>
		</table>
	);
};

export default TableHeader;
